module.exports = __webpack_public_path__ + "./cathy_7d1f5cd11ea5f3b272d85e21511035f8.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2018/cathy.png
// module id = 457
// module chunks = 0